import { render, staticRenderFns } from "./Use_common_monitor.vue?vue&type=template&id=2c887f53&"
import script from "./Use_common_monitor.vue?vue&type=script&lang=js&"
export * from "./Use_common_monitor.vue?vue&type=script&lang=js&"
import style0 from "./Use_common_monitor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports